import { getCheckoutClient } from "../config/CheckoutClient";

export const setPaymentPlansDynamicData = (data) => {
    return {
        type: 'SET_PAYMENT_PLANS_DYNAMIC_DATA',
        data,
    }
}

export const setPaymentPlan = (paymentPlanId) => {
    return {
        type: 'SELECT_PAYMENT_PLAN',
        paymentPlanId,
    }
}

export function fetchPaymentPlans(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'payment-plans', secret).then((result) => {
            if (result?.ok && result.body?.paymentPlans) {
                dispatch(setPaymentPlansDynamicData(result.body.paymentPlans));
                return Promise.resolve();
            }
            return Promise.reject();
        });
    }
}
